import React from 'react';

import { ITEM_GRID_COUNT } from '../config';
import { interfaceTypes } from '../constants';

import getKeyByValue from './getKeyByValue';
import isMappedTo from './isMappedTo';

function getRelationshipDisplayTypeComponent (interfaceType, relationshipItems) {

	switch (isMappedTo.group.interfaceType.which(interfaceType)) {

		case 'slider': {

			if (relationshipItems.length > ITEM_GRID_COUNT) {

				const RelationshipItemsSlider = React.lazy(() => import('../components/RelationshipItemsSlider'));
				return RelationshipItemsSlider;

			}

			const RelationshipItemsNoSlider = React.lazy(() => import('../components/RelationshipItemsNoSlider'));
			return RelationshipItemsNoSlider;

		}

		case 'overflow': {

			const RelationshipItemsOverflow = React.lazy(() => import('../components/RelationshipItemsOverflow'));

			return RelationshipItemsOverflow;

		}

		default: {

			const RelationshipItemsNoMapping = () => {

				console.error(`Interface Type "${getKeyByValue(interfaceTypes, interfaceType)}" has no mapping.`);

				return <div />;

			};
			return RelationshipItemsNoMapping;

		}

	}

}

export default getRelationshipDisplayTypeComponent;
